import {computed, inject, Injectable} from "@angular/core";
import {UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {StationStore} from "@shared/store";

@Injectable({
    providedIn: "root"
})
export class HasStationGuard {
    readonly stationStore = inject(StationStore);
    readonly station = computed(() => this.stationStore.selectedStation());

    canActivate(): Observable<boolean> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return !!this.station();
    }

}
